import React, {Suspense, useEffect} from "react";
import Styles from './styles.module.scss';
import {Route, Routes, Outlet, useLocation} from "react-router-dom";
import FuturePage from "../../pages/futurePage";
import Header from "../header";
import Footer from "../footer";
import {useSyncLangFromUrl} from "../../hooks/useSyncLangFromUrl";
import TokenomicsPage from "../../pages/tokenomicsPage";
import TeamPage from "../../pages/teamPage";
import ApostolPage from "../../pages/aposolPage";
import WhitePaperPage from "../../pages/whitePaperPage";
import LogPage from "../../pages/logPage";
import RegPage from "../../pages/regPage";
import ForgotPage from "../../pages/forgotPage";
import ResetPage from "../../pages/resetPage";
// import CabinetPage from "../../pages/cabinetPage";
import PreSalePage from "../../pages/preSalePage";
import CabinetHeader from "../cabinetHeader";
import CabinetPreSalePage from "../../pages/cabinet/cabinetPreSalePage";
import {useDispatch, useSelector} from "react-redux";
import {getUserData} from "../../store/cabinet/action";
import {isEarlyAccessGranted} from "../../helpers/user";

import absTable from '../../theme/assets/other/tc_cab_abs_table.png';
import CabinetSettingsPage from "../../pages/cabinet/cabinetSettingsPage";
import CabinetApostolPage from "../../pages/cabinet/cabinetApostolPage";
import CabinetCapsulePage from "../../pages/cabinet/cabinetCapsulePage";
import CabinetEventsPage from "../../pages/cabinet/cabinetEventsPage";
import NotFoundPage from "../../pages/notFoundPage";
import CabinetEarlyAccessPage from "../../pages/cabinet/cabinetEarlyAccessPage";

import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import CabinetPage from "../../pages/cabinetPage";

// Страница цифровой копии тянет three.js и drei — это сотни килобайт,
// которые не нужны на остальных экранах. Грузим её отдельным чанком.
const CabinetAvatarPage = React.lazy(()=> import("../../pages/cabinet/cabinetAvatarPage"));



// const MainLayout = () => (
//     <div className={`${Styles.main}`}>
//         <Header/>
//         <Outlet/>
//         <Footer/>
//     </div>
// );

const FutureLayout = () => (
    <div className={`${Styles.main} ${Styles.futureBg}`}>
        <Header />
        <Outlet />
        <Footer />
    </div>
);

const TeamLayout = () => (
    <div className={`${Styles.main} ${Styles.teamBg}`}>
        <Header />
        <Outlet />
        <Footer />
    </div>
);

const TokenomicsLayout = () => (
    <div className={`${Styles.main} ${Styles.tokenomicsBg}`}>
        <Header />
        <Outlet />
        <Footer />
    </div>
);

const ApostolLayout = () => (
    <div className={`${Styles.main} ${Styles.apostolBg}`}>
        <Header />
        <Outlet />
        <Footer />
    </div>
);

const WpLayout = () => (
    <div className={`${Styles.main} ${Styles.wpBg}`}>
        <Header />
        <Outlet />
        <Footer />
    </div>
);

const AuthLayout = () => (
    <div className={`${Styles.main} ${Styles.authBg}`}>
        <Header />
        <Outlet />
        <Footer />
    </div>
);

const PreSaleLayout = () => (
    <div className={`${Styles.main} ${Styles.preSaleBg}`}>
        <Header />
        <Outlet />
        <Footer />
    </div>
);

const CabinetLayout = () => {
    const location = useLocation();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const userData = useSelector(store => store.cabinet.userData);
    const userDataErr = useSelector(store => store.cabinet.userDataErr);

    // Кабинет открыт только участникам альфа-теста. Статус живёт в GET /user,
    // поэтому до его приезда не рисуем ничего: иначе кабинет мигал бы тому,
    // кого внутрь пускать нельзя. Если запрос упал (сеть, сертификат, 500),
    // ждать нечего — показываем кабинет, пусть страницы разбираются сами,
    // иначе человек смотрит на пустой экран
    const earlyAccess = userData?.user?.early_access_status;
    const isWaitingUser = authStatus && !userData && !userDataErr;
    const isBlocked = !!userData?.user && !isEarlyAccessGranted(earlyAccess);

    // на главной, странице капсулы и в программе "Апостол" декоративный стол не выводится
    const isWithoutAbsTable = location.pathname.startsWith('/cabinet/apostol')
            || location.pathname.startsWith('/cabinet/capsule')
            || location.pathname === '/cabinet'
            || location.pathname.startsWith('/cabinet/events')
            || location.pathname.startsWith('/cabinet/avatar');

    if (isWaitingUser){
        return <div className={`${Styles.cabinet}`}/>;
    }

    if (isBlocked){
        return (
            <div className={`${Styles.cabinet}`}>
                <CabinetEarlyAccessPage/>
            </div>
        );
    }

    return (
        <div className={`${Styles.cabinet}`}>
            <div className={`${Styles.posWrap}`}>
                <CabinetHeader/>
                <div className={`${Styles.cabinetWrap}`}>
                    <Outlet />
                </div>
                {!isWithoutAbsTable ? (
                    <div className={`${Styles.cabinetAbsTable}`}>
                        <img src={absTable} alt="abs table"/>
                    </div>
                ) : null}
            </div>
        </div>
    );
};


const App = () => {
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useSyncLangFromUrl();

    useEffect(()=>{
        if (authStatus){
            dispatch(getUserData());
        }
    },[authStatus, dispatch])

    return (
        <section className={`${Styles.container}`}>
            <Routes>
                <Route element={<FutureLayout/>}>
                    <Route path='/' element={<FuturePage />} />
                    <Route exact path='/future' element={<FuturePage/>}/>
                    <Route exact path='/invite/:id' element={<FuturePage/>}/>
                </Route>
                <Route element={<TokenomicsLayout/>}>
                    <Route exact path='/tokenomics' element={<TokenomicsPage/>}/>
                </Route>
                <Route element={<TeamLayout/>}>
                    <Route exact path='/team' element={<TeamPage/>}/>
                </Route>
                <Route element={<ApostolLayout/>}>
                    <Route exact path='/apostol' element={<ApostolPage/>}/>
                </Route>
                <Route element={<WpLayout/>}>
                    <Route exact path='/white-paper' element={<WhitePaperPage/>}/>
                </Route>
                <Route element={<PreSaleLayout/>}>
                    <Route exact path='/pre-sale' element={<PreSalePage/>}/>
                </Route>
                <Route element={<AuthLayout/>}>
                    <Route exact path='/sign-in' element={<LogPage/>}/>
                    <Route exact path='/sign-up' element={<RegPage/>}/>
                    {/* реферальная ссылка: код подхватывается через useParams */}
                    <Route exact path='/sign-up/:referralCode' element={<RegPage/>}/>
                    {/* восстановление пароля: запрос письма и страница из ссылки */}
                    <Route exact path='/forgot-password' element={<ForgotPage/>}/>
                    <Route exact path='/reset-password' element={<ResetPage/>}/>
                </Route>
                <Route element={<CabinetLayout/>}>
                    <Route exact path='/cabinet' element={<CabinetPage/>}/>
                    <Route exact path='/cabinet/pre-sale' element={<CabinetPreSalePage/>}/>
                    <Route exact path='/cabinet/settings' element={<CabinetSettingsPage/>}/>
                    <Route exact path='/cabinet/apostol' element={<CabinetApostolPage/>}/>
                    <Route exact path='/cabinet/capsule' element={<CabinetCapsulePage/>}/>
                    <Route exact path='/cabinet/events' element={<CabinetEventsPage/>}/>
                    <Route
                        exact
                        path='/cabinet/avatar'
                        element={(
                            <Suspense fallback={null}>
                                <CabinetAvatarPage/>
                            </Suspense>
                        )}
                    />
                    <Route path='/cabinet/*' element={<NotFoundPage/>}/>
                </Route>

                {/* всё остальное — обычный макет с хедером и подвалом */}
                <Route element={<FutureLayout/>}>
                    <Route path='*' element={<NotFoundPage/>}/>
                </Route>
            </Routes>
            <ToastContainer/>
        </section>
    );
};

export default App;